import { Helper } from '../../../../classes/helper'
import { useMontage } from '../../../../context/montage.context'
import { MarqueeModelMain } from '../model/marquee/MarqueeModelMain'

export const Marquee = (): JSX.Element | null => {
  const { marquee } = useMontage()

  // TODO: Add a status class
  if (marquee.type === '- Ohne Markise -') return null

  return (
    <group
      castShadow
      rotation={[0, Helper.convertAngleToRadiant(90), 0]}
      position={[
        Helper.convertToMeter(0),
        Helper.convertToMeter(-20),
        Helper.convertToMeter(0),
      ]}
    >
      <MarqueeModelMain type={marquee.type} />
    </group>
  )
}
